import { ContentContainer } from "@/components/ContentContainer";
import KnowledgeList from "@/components/knowledge/KnowledgeList";
import theme from "@/styles/theme";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import PageHead from "@/components/PageHead";
import { getKnowledgebaseCategories } from "@/lib/api";

export default function Wissenswertes({page, categories}) {

  return (
      <>
        <PageHead page={page} />
        <ContentContainer
          headline={page.headline}
          image={page?.heroimage?.formats?.large?.url}
        >
          <Typography
            variant="body2"
            sx={{
              mb: 3,
              [theme.breakpoints.up("sm")]: {
                mb: 6,
              },
            }}
          >
            {page.index_introduction}
          </Typography>

          <KnowledgeList categories={categories} />
        </ContentContainer>
      </>
  );
}

export const getStaticProps = async() => {
  const pageResponse = await fetch(`${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/page-knowledgebase`);
  const page = await pageResponse.json();

  const categories = await getKnowledgebaseCategories();

  return {
    props: {
      page,
      categories
    },
    revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT)
  }
}